<div class="template-editor-container">
  <div class="comment-composer-box">
    <form [formGroup]="form" [formEditablePermission]="form">
      <div class="p-3">
        <div class="d-flex align-items-center gap-3">
          <mat-form-field2 class="mat-block">
            <input type="text" matInput required i18n-placeholder placeholder="Template Name" formControlName="name" />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              <ng-container i18n>Template Name is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')">
              <ng-container i18n>Template Name must be at least 2 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')">
              <ng-container i18n>Template Name must be at most 100 characters long</ng-container>
            </mat-error>
            <mat-hint align="end">{{ form.get('name').value.length || 0 }}/100</mat-hint>
          </mat-form-field2>
          <div class="flex-fill"></div>
          <mat-form-field2
            class="mat-block"
            [hidePlaceholder]="true"
            style="min-width: 170px; width: 170px"
            *ngIf="showType"
          >
            <mat-select
              i18n-matTooltip
              i18n-placeholder
              matTooltip="Change the type of this template."
              matTooltipPosition="above"
              formControlName="type"
              placeholder="Change type"
            >
              <mat-option [value]="types.Email" i18n>Email</mat-option>
              <mat-option [value]="types.PushNotification" i18n>Mobile</mat-option>
              <mat-option [value]="types.Payload" i18n>API Payload</mat-option>
              <mat-option [value]="types.Review" i18n>Review</mat-option>
            </mat-select>
          </mat-form-field2>
          <div
            *ngIf="templateType === types.Review"
            style="min-width: 170px; width: 170px"
            matTooltip="This template will be used if booking rating matches the rating defined here"
            i18n-matTooltip
            class="mb-4"
          >
            <div class="form-field-label mb-3">Assign Booking Rating</div>
            <app-rating
              [rating]="form.get('rating').value"
              [editable]="true"
              (rate)="form.get('rating').setValue($event)"
            ></app-rating>
          </div>
          <button
            (click)="editor.onDataDictionary()"
            [disabled]="1 | isReadonlyRole"
            i18n-matTooltip
            matTooltip="You may insert data tokens using data dictionary."
            matTooltipPosition="above"
            type="button"
            class="btn btn-secondary-primary"
          >
            <span class="cs-icon cs-icon-book"></span> <ng-container i18n>data dictionary</ng-container>
          </button>
          <button
            (click)="onSave(form)"
            class="btn btn-secondary-info save-btn"
            type="button"
            *ngIf="showSaveBtn"
            [disabled]="1 | isReadonlyRole"
          >
            <i class="cs-icon cs-icon-save"></i><ng-container i18n>Save</ng-container>
          </button>
        </div>
      </div>

      <app-editor-email
        *ngIf="templateType === types.Email"
        [type]="templateType"
        [contentCtrl]="form.get('body')"
        [subjectCtrl]="form.get('subject')"
        #editor
      ></app-editor-email>

      <app-editor-plaintext
        *ngIf="templateType === types.PushNotification || templateType === types.Review"
        [type]="templateType"
        [contentCtrl]="form.get('body')"
        #editor
      ></app-editor-plaintext>

      <app-editor-http
        *ngIf="templateType === types.Payload"
        [type]="templateType"
        [contentCtrl]="form.get('body')"
        [subjectCtrl]="form.get('subject')"
        #editor
      ></app-editor-http>
    </form>
  </div>
</div>
